"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNativeBalanceOperation = void 0;
var common_core_1 = require("@moralisweb3/common-core");
var dataTypes_1 = require("../../dataTypes");
var EvmChainResolver_1 = require("../../EvmChainResolver");
/** Get the native balance for a specific wallet address. */
exports.getNativeBalanceOperation = {
    method: 'GET',
    name: 'getNativeBalance',
    id: 'getNativeBalance',
    groupName: 'balance',
    urlPathPattern: '/{address}/balance',
    urlPathParamNames: ['address'],
    urlSearchParamNames: ['chain', 'toBlock'],
    getRequestUrlParams: getRequestUrlParams,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
    deserializeResponse: deserializeResponse,
};
// Methods
function getRequestUrlParams(request, core) {
    return {
        chain: EvmChainResolver_1.EvmChainResolver.resolve(request.chain, core).apiHex,
        to_block: (0, common_core_1.maybe)(request.toBlock, String),
        address: dataTypes_1.EvmAddress.create(request.address, core).checksum,
    };
}
function deserializeResponse(jsonResponse) {
    return {
        balance: dataTypes_1.EvmNative.create(jsonResponse.balance, 'wei'),
    };
}
function serializeRequest(request, core) {
    return {
        chain: EvmChainResolver_1.EvmChainResolver.resolve(request.chain, core).apiHex,
        toBlock: request.toBlock,
        address: dataTypes_1.EvmAddress.create(request.address, core).lowercase,
    };
}
function deserializeRequest(jsonRequest, core) {
    return {
        chain: dataTypes_1.EvmChain.create(jsonRequest.chain, core),
        toBlock: jsonRequest.toBlock,
        address: dataTypes_1.EvmAddress.create(jsonRequest.address, core),
    };
}
//# sourceMappingURL=getNativeBalanceOperation.js.map